import { UserPortfolioItemViewModel } from "../../../../configuration/api/apiSchema";
import { updateObject } from "../../../../helpers/updateObject";
import { GET_USER_PORTFOLIO, UPDATE_USER_PORTFOLIO } from "./actions";

export type UserPortfolioState = {
    isLoading: boolean;
    isError: boolean;
    isListUpdated: boolean;
    userPortfolioItems?: UserPortfolioItemViewModel[];
}

const initialState = {
    isLoading: false,
    isError: false,
    isListUpdated: false,
    userPortfolioItems: undefined,
};

export const reducer = (state: UserPortfolioState = initialState, action: any) => {
    switch (action.type) {
        case GET_USER_PORTFOLIO.REQUEST:
            return updateObject(state, { isLoading: true, isError: false });
        case GET_USER_PORTFOLIO.SUCCESS:
            return updateObject(state, { isLoading: false, userPortfolioItems: action.userPortfolioItems });
        case UPDATE_USER_PORTFOLIO.REQUEST:
            return updateObject(state, { isLoading: true, isError: false, isListUpdated: false });
        case UPDATE_USER_PORTFOLIO.SUCCESS:
            return updateObject(state, { isLoading: false, userPortfolioItems: action.userPortfolioItems, isListUpdated: true });

        default:
            return state;
    }
};